export default "<a class=\"qtty-link\" (click)=\"sendInfo()\">{{ quantity }}</a>\n"